import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sas-clinic-oem-header',
  templateUrl: './sas-clinic-oem-header.component.html',
  styleUrls: ['./sas-clinic-oem-header.component.css'],
})
export class SasClinicOemHeaderComponent implements OnChanges {
  imgpath: string;

  @Input()
  clientId: string;

  ngOnChanges(changes: SimpleChanges): void {
    this.imgpath = environment.apps[this.clientId].oemConfig?.imgpath;
  }
}
